/**
 * Selector that returns the length of the completed questions.
 */

import { createSelector } from 'reselect';

import questionsCompletedSelector from './questionsCompletedSelector';

export default createSelector(questionsCompletedSelector, (questions) => {
  if (questions && questions?.length > 0) {
    return questions.length;
  }
  return 0;
});
